export type SingleTeamType = {
  id: string;
  name: string;
  status: string;
  phoneNumber: string;
  action?: number;
  email?: string;
  restrictPositions?: boolean;
};

export type SingleTeamInviteType = {
  id: string;
  email: string;
  status: string;
  state: string;
  userId: string;
  action?: number;
  restrictPositions?: boolean;
};

export type TeamMemberInfoType = {
  user: string;
  inviteeEmail: string;
  accountInviteId?: string;
};

export enum TeamMemberAction {
  DELETE = 'delete',
  PROMOTE = 'promote',
  DEMOTE = 'demote',
  RESTRICT = 'restrict',
  UNRESTRICT = 'unRestrict',
  OUTLOOK_LOGIN = 'outlookLogin',
}

export enum TeamInviteAction {
  CANCEL = 'cancel',
  REINVITE = 'reinvite',
}
